export default [{
  path: '/dashboards-comercial',
  name: 'dashboard-comercial',
  component: () => import('@/app-modulo/comercial/dashboard-comercial/DashboardComercial.vue'),
  meta: {
    resource: 'dashboardcomercial',
    action: 'read',
    navActiveLink: 'dashboard-comercial',
    pageTitle: 'Dashboard comercial',
  },
}]
